import React from 'react'
import dayjs from 'dayjs'
import styled from '@emotion/styled'
import { FiBell, FiCheck, FiChevronDown, FiChevronRight } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { useDropdown } from '@context/DropdownContext'
import {
  BellIcon,
  ChevronIcon,
  Divider,
  DropdownContainer,
  Empty,
  EmptyIcon,
  EmptySubtext,
  Header,
  Item,
  ItemBody,
  ItemDate,
  ItemFooter,
  ItemHeader,
  ItemTime,
  ItemTitle,
  List,
  MarkReadButton,
  Title,
  UnreadBadge,
  UnreadCount,
  ViewAll,
} from './style'

interface Notification {
  id: number
  title: string
  body: string
  createdAt: string
  read?: boolean
}

interface Props {
  notifications: Notification[]
  totalPages?: number
  totalItems?: number
  setPage?: (val: number) => void
}

const NotificationDropdown: React.FC<Props> = ({
  notifications,
  totalItems,
}) => {
  const navigate = useNavigate()
  const { hideDropdown } = useDropdown()
  return (
    <DropdownContainer>
      <Header>
        <Title>
          <BellIcon />
          <span>Notifications</span>
          <UnreadCount>{totalItems}</UnreadCount>
        </Title>
        <ViewAll
          onClick={() => {
            navigate('/admin/notifications')
            hideDropdown()
          }}
        >
          View all <ChevronIcon />
        </ViewAll>
      </Header>

      <Divider />

      {notifications.length === 0 ? (
        <Empty>
          <EmptyIcon />
          <div>No new notifications</div>
          <EmptySubtext>You're all caught up</EmptySubtext>
        </Empty>
      ) : (
        <List>
          {notifications.map((notification) => (
            <Item
              key={notification.id}
              unread={!notification.read}
              onClick={() => {
                navigate('/admin/notifications')
                hideDropdown()
              }}
            >
              <ItemHeader>
                <ItemTitle>{notification.title}</ItemTitle>
                <ItemTime>
                  {dayjs(notification.createdAt).format('HH:mm')}
                </ItemTime>
                {!notification.read && <UnreadBadge />}
              </ItemHeader>
              <ItemBody>{notification.body}</ItemBody>
              <ItemFooter>
                <ItemDate>
                  {dayjs(notification.createdAt).format('MMM D, YYYY')}
                </ItemDate>
                <MarkReadButton>
                  <FiCheck size={14} />
                </MarkReadButton>
              </ItemFooter>
            </Item>
          ))}
        </List>
      )}
    </DropdownContainer>
  )
}

export default NotificationDropdown
